/* eslint-disable no-shadow */
import {
  all, call, put, takeLatest
} from 'redux-saga/effects'
import { Api, FixtureApi } from '../services'
import {
  postBriefFormSuccess, postBriefFormFailed, postJoinFormSuccess, postJoinFormFailed
} from '../redux/reducer'
import debugConfig from '../config/debugConfig'

const api = debugConfig.useFixtures ? FixtureApi : Api.create()


function * postBriefUsForm (action) {
  try {
    const result = yield call(api.submitBriefForm, action.payload)
    yield put(postBriefFormSuccess(result.data))
    let dataLayer = window.dataLayer = window.dataLayer || []
    if (dataLayer) {
      dataLayer.push({'event': 'postBriefFormSuccess', 'page': window.location.href})
    }
  } catch (error) {
    yield put(postBriefFormFailed(error))
  }
}

function * postJoinUsForm (action) {
  try {
    const result = yield call(api.submitJoinUsForm, action.payload)
    yield put(postJoinFormSuccess(result.data))
  } catch (error) {
    yield put(postJoinFormFailed(error))
  }
}

export default function * rootSaga () {
  yield all([
    takeLatest('POST_BRIEF_FORM_REQUEST', postBriefUsForm),
    takeLatest('POST_JOIN_FORM_REQUEST', postJoinUsForm)
  ])
}

/* eslint-enable */


